<template>
  <a-modal :title="form.account_id ? '修改账户信息' : '新增账户信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false" width="660px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="账户名称" prop="account_name">
        <a-radio-group v-model="form.account_type" :disabled="!!form.account_id">
          <a-radio value="1">
            银行卡账户
          </a-radio>
          <a-radio value="2">
            支付宝账户
          </a-radio>
          <a-radio value="3">
            微信账户
          </a-radio>
          <a-radio value="4">
            其他账户
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="账户名称" prop="account_name">
        <a-input v-model="form.account_name" placeholder="请输入账户名称" :disabled="!!form.account_id" />
      </a-form-model-item>
      <a-form-model-item label="账户地址" prop="account_number">
        <a-input v-model="form.account_number" placeholder="请输入账户地址（卡号或帐号）" :disabled="!!form.account_id" />
      </a-form-model-item>
      <a-form-model-item label="卡户银行" prop="bank_name" v-if="form.account_type == '1'">
        <a-input v-model="form.bank_name" placeholder="请输入卡户银行" :disabled="!!form.account_id" />
      </a-form-model-item>
      <a-form-model-item label="开户支行" prop="bank_branch" v-if="form.account_type == '1'">
        <a-input v-model="form.bank_branch" placeholder="请输入开户支行" :disabled="!!form.account_id" />
      </a-form-model-item>
      <!-- <a-form-model-item label="是否可收款">
        <a-switch :checked="form.income === '1'" @change="(bol) => form.income = bol ? '1' : '0'" />
      </a-form-model-item>
      <a-form-model-item label="是否可付款">
        <a-switch :checked="form.pay === '1'" @change="(bol) => form.pay = bol ? '1' : '0'" />
      </a-form-model-item> -->
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="备注" />
      </a-form-model-item>
      <a-form-model-item label="是否在用" prop="enable">
        <a-switch :checked="form.enable === '1'" @change="(bol) => form.enable = bol ? '1' : '0'" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        account_id: null,
        account_type: "1",
        // income: "1",
        // pay: "1",
        account_name: "",
        account_number: "",
        bank_name: "",
        bank_branch: "",
        remark: "",
        enable: "1"
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        account_name: [
          {
            required: true,
            message: "请输入账户名称",
            trigger: "blur",
          },
        ],
        account_number: [
          {
            required: true,
            message: "请输入账户地址",
            trigger: "blur",
          },
        ],
        bank_name: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: "blur",
          },
        ],
        bank_branch: [
          {
            required: true,
            message: "请输入开户支行",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.account_id = id;
      if (id) {
        this.$http({
          url: "/admin/account/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data
          }
        });
      }
      this.getMenuPage();
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
          };
          this.$http({
            url: this.form.account_id ? "/admin/account/update" : "/admin/account/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.account_id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>